module.exports = __webpack_public_path__ + "img/close.2d646ec2.svg";